'use client';
import React, { ChangeEvent } from 'react';

import classNames from 'classnames';
import currency from 'currency.js';

import styles from './selection-button.module.scss';

import {
  renderBadge,
  renderPrice,
  renderExtraInfo,
} from './selection-button-util';

export interface SelectionButtonMainProps {
  sku: string;
  isDisabled?: boolean;
  name: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
  description?: string;
  image?: string;
  popular?: boolean;
  backOrderShipping?: boolean;
  thumbnail?: string;
  title?: string;
  price?: number | currency;
  outOfStock?: boolean;
}

export const SelectionButtonMain = ({
  sku,
  onChange,
  name,
  description,
  checked,
  isDisabled,
  image,
  popular,
  backOrderShipping,
  thumbnail,
  title = '',
  price,
  outOfStock,
}: SelectionButtonMainProps) => (
  <div className={styles['button-container']}>
    <label
      className={`button-label`}
      data-testid="button-label-test"
      aria-label={name}
    >
      <input
        id={sku}
        data-image={image}
        onChange={onChange}
        data-testid={sku}
        disabled={isDisabled || outOfStock}
        className={
          isDisabled || outOfStock
            ? styles['button-disabled']
            : styles['button']
        }
        type="radio"
        name={name}
        value={sku}
        checked={!isDisabled && checked}
        tabIndex={0}
      />
      <div
        className={styles['label-container']}
        data-testid="label-container-test"
      >
        <div className={styles['label-container-wrapper']}>
          {renderBadge(popular, outOfStock, backOrderShipping)}
          <div className={styles['description-container']}>
            <div className={styles['image-container']}>
              <img
                src={thumbnail || image}
                className={styles['img']}
                alt={title}
              />
            </div>
            <div
              className={styles['text-container']}
              data-testid="text-container-test"
            >
              <div className={styles['title-row-content']}>
                <div
                  className={classNames(styles['title'], 'body-extra-large')}
                >
                  {title}
                </div>
                <span className={styles['separator']}>{'|'}</span>
                <span className={classNames(styles['name'], 'body-large')}>
                  {name}
                </span>
              </div>
              <div className={styles['second-row-content']}>
                <div className={styles['description']} id="description">
                  <span
                    className={classNames('caption-regular')}
                    dangerouslySetInnerHTML={{
                      __html: description || '',
                    }}
                  />
                </div>
                {renderPrice(checked, price || 0)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </label>
    {renderExtraInfo(outOfStock, backOrderShipping)}
  </div>
);
